import type { GroupProps, StackProps } from '@mantine/core';
import { Group, Stack } from '@mantine/core';
import React from 'react';

import { useIsMobile } from '~/domains/common/hooks/mediaQueries';

type GroupToStackProps = {
  children: React.ReactNode;
  stackProps?: StackProps;
  groupProps?: GroupProps;
  forceMobile?: boolean;
};

export function GroupToStack({
  children,
  stackProps = {},
  groupProps = {},
  forceMobile,
}: GroupToStackProps) {
  const isMobile = useIsMobile();

  if (isMobile || forceMobile) {
    return <Stack {...stackProps}>{children}</Stack>;
  }

  return <Group {...groupProps}>{children}</Group>;
}
